import expressMiddlewareAdapter from './expressMiddlewareAdapter.js';
export default expressMiddlewareAdapter;